import { Component, OnInit, Input, Output, TemplateRef, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FilterOutput, FilterInput } from "./filter-v3.types";


@Component({
  selector: 'app-filter-v3',
  templateUrl: './filter-v3.component.pug',
  styleUrl: './filter-v3.component.scss',
  standalone: false
})
export class FilterV3Component implements OnInit {
  @Input() filterInput: FilterInput[] = [];
  @Input() usePopover = false; // switch this to use a popup instead of a filter dropdown
  @Input() storageKey?: string;
  @Output() applyFilter = new EventEmitter();
  modalRef?: BsModalRef;
  filterOutput: FilterOutput = {};
  filterCount = 0;
  @ViewChild('popoverFilter', {static: false}) filterDropdown: any;

  ngOnInit() {
  }

  constructor(private modalService: BsModalService) {}

  processFilterInput(): void {
    let stored: string | null = '';
    // parts of this.filterInput might need to be requested from the server, we shouldn't try to
    // initialise filters until it has been retrieved.  ngOnChanges will call this function
    // when filterInput is loaded.
    if (this.storageKey && Object.keys(this.filterInput).length > 0) {
      stored = localStorage.getItem(this.storageKey);
      if (stored) {
        this.filterOutput = JSON.parse(stored);
        this.applyFilter.emit(this.filterOutput);
        this.resetFilterCount();
      }
    }
    if (!stored && Object.keys(this.filterInput).length > 0) {
      this.reset();
      this.resetFilterCount();
      this.applyFilter.emit(this.filterOutput);
    }
  }

  resetFilterCount(): void {
    let count = 0;
    this.filterInput.forEach(field => {
      if (field.type === 'filterToggleGroup') {
        if (this.filterOutput[field.key].length > 0) {
          count += 1;
        }
      }
    });
    this.filterCount = count;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.filterInput && changes.filterInput.currentValue?.length) || changes.storageKey) {
      this.processFilterInput();
    }
  }
  openModal(template: TemplateRef<any>): void {
    this.modalRef = this.modalService.show(template, {class: 'modal-dialog-centered'});
  }

  reset(): void {
    this.filterInput.forEach(field => {
      if (field.type === 'filterToggleGroup') {
        this.filterOutput[field.key] = [];
        field.options.forEach(option => {
          if (option.selected) {
            this.filterOutput[field.key].push(option.value);
          }
        });
      }
    });
  }

  cancel(): void {
    if (!this.usePopover && this.modalRef) {
      this.modalRef.hide();
    } else {
      this.filterDropdown.hide();
    }
  }

  handleChange(type: string, key: string, value: string) {
    if (type === 'filterToggleGroup') {
      if (!this.filterOutput[key].includes(value)) {
        this.filterOutput[key].push(value);
      } else {
        this.filterOutput[key] = this.filterOutput[key].filter(item => item !== value);
      }
    }
  }


  apply() {
    /*
      We should end up with a simple output like below
      {
        location: 'Townsville',
        distance: '10',
        created_by: ['xref', 'org_name'],
        status: ['active'],
        optedInDate: 'tech'
      }
    */
    if (!this.usePopover && this.modalRef) {
      this.modalRef?.hide();
    } else {
      this.filterDropdown?.hide();
    }
    this.applyFilter.emit(this.filterOutput);
    if (this.storageKey) {
      localStorage.setItem(this.storageKey, JSON.stringify(this.filterOutput));
    }
    this.resetFilterCount();
  }

  disableApply() {
    return false;
  }
}
